import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { utils } from '@ims/1edtech-frontend-common'

import { getRequest } from 'lib/api/api'
import { getAccessToken } from 'lib/api/utils'
import users from 'lib/records/modules/users'
import { mergeOrReplaceEntities } from 'lib/records/workflows/entities'
import store from 'lib/store'
import { setApplicationProperties } from 'domains/application/ducks/application'
import { applicationPropSelector } from 'domains/application/selectors/application'
import { initialize } from 'domains/application/workflows/initialize'
import { useLogout } from './useLogout'

interface Options {
  enabled: boolean
}

export interface LoginError {
  errorCode: string
  message: string
}

interface Login {
  success: boolean
  error?: LoginError
}

export const auth0Login = async () => {
  const accessToken = getAccessToken()

  let response: Login = { success: false }

  if (!accessToken) return

  const loginResponse = await getRequest('login')

  if (!loginResponse.success) {
    if (loginResponse.data) response.error = loginResponse.data
    return response
  }

  const me = await mergeOrReplaceEntities(
    false,
    users,
    loginResponse.data,
    false,
  )
  store.dispatch(setApplicationProperties({ me }))
  await initialize()
  response.success = true
  return response
}

export const useAuth0AutoLogin = ({ enabled }: Options) => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0()
  const me = utils.convertToInt(useSelector(applicationPropSelector('me')))

  const logout = useLogout()

  useEffect(() => {
    if (!enabled) return
    if (isLoading) return

    const login = async () => {
      try {
        await loginWithRedirect()
        await auth0Login()
      } catch (e) {
        logout()
      }
    }

    if (!isAuthenticated && me <= 0) {
      login()
    }
  }, [enabled, isLoading, isAuthenticated, me, loginWithRedirect, logout])
}
